import { HeroUIProvider, ToastProvider } from "@heroui/react";
import { posthogConfig } from "@onesolution/config";
import { QueryClientProvider } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { PostHogProvider } from "posthog-js/react";
import { type PropsWithChildren, StrictMode } from "react";

import { useLanguage } from "@onesolution/hooks";
import queryClient from "./queryClient";

export default function ProvidersWrapper({ children }: PropsWithChildren) {
	const router = useRouter();
	const { locale } = useLanguage();

	// TODO: change PostHog condition when multiple projects are enabled on PostHog dashboard
	function renderPostHog(children: React.ReactNode) {
		const isProd = import.meta.env.PROD;

		return isProd ? (
			<PostHogProvider
				apiKey={process.env.PUBLIC_POSTHOG_KEY}
				options={posthogConfig}
			>
				{children}
			</PostHogProvider>
		) : (
			children
		);
	}

	return (
		<StrictMode>
			{renderPostHog(
				<HeroUIProvider
					locale={locale}
					navigate={(to, options) => router.navigate({ to, ...options })}
					useHref={(to) => router.buildLocation({ to }).href}
				>
					<NextThemesProvider attribute="class" defaultTheme="light">
						<QueryClientProvider client={queryClient}>
							<div className="bg-bubble bg-background text-foreground h-screen w-screen transition-colors">
								{children}
							</div>
						</QueryClientProvider>
					</NextThemesProvider>
					<ToastProvider />
				</HeroUIProvider>,
			)}
		</StrictMode>
	);
}
